import { render, staticRenderFns } from "./waitDealFeedbackView.vue?vue&type=template&id=18fda0a5&"
import script from "./waitDealFeedbackView.vue?vue&type=script&lang=js&"
export * from "./waitDealFeedbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports